module.exports = __webpack_public_path__ + "static/media/test-kit-placeholder.078f23aa.png";